<template>
    <section style="overflow: hidden;">
        <titlebar :title-stack="titleStack">
            <div slot="right" v-if="model.id">
                <span v-if="!model.temPendencia" class="tag is-success">Sem pendências financeiras</span>
                <span v-else class="tag is-danger">
                    {{model.temPendenciaTexto}}
                </span>
            </div>
        </titlebar>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="tile is-ancestor">
                    <div class="tile is-parent is-vertical is-9">
                        <article class="tile is-child box">

                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="required" name="model.nome" v-slot="{ errors, valid }">
                                        <b-field label="Nome"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" v-model="model.nome"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-2">
                                    <div class="field">
                                        <b-switch v-model="nomeSocial">
                                            Nome Social
                                        </b-switch>
                                    </div>
                                    <div class="field">
                                        <b-switch v-show="config.laboratorioVeterinario" v-model="animal">
                                            Animal
                                        </b-switch>
                                    </div>
                                </div>
                            </div>

                            <div class="columns" v-if="nomeSocial">
                                <div class="column">
                                    <b-field label="Nome Social">
                                        <b-input type="text" v-model="model.nomeSocial"></b-input>
                                    </b-field>
                                </div>
                            </div>

                            <buscaCepEndereco :cep.sync="model.cep"
                                              :endereco.sync="model.endereco"
                                              :bairro.sync="model.bairro"
                                              :cidadeid.sync="model.cidadeId"
                                              :cidadenome.sync="model.cidadeNome"></buscaCepEndereco>

                            <div class="columns">
                                <div class="column">
                                    <b-field label="Fone">
                                        <b-input v-model="model.fone" v-mask="['(##) ####-####', '(##) #####-####']"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Celular">
                                        <b-input expanded
                                                 v-model="model.celular" 
                                                 v-mask="['(##) ####-####', '(##) #####-####']"
                                                 :icon-right-clickable="podeEnviarSms"
                                                 @icon-right-click="abrirModalSms"
                                                 :icon-right="iconeEnviarSms"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <div class="field">
                                        <b-switch v-model="model.enviaSMS">
                                            Envia mensagens SMS
                                        </b-switch>
                                    </div>
                                </div>
                            </div>

                            <div class="columns is-multiline is-mobile">
                                <div class="column is-full-mobile">
                                    <ValidationProvider rules="required" name="sexo" v-slot="{ errors, valid }">
                                        <b-field label="Sexo"
                                                 :message="errors"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }">
                                            <b-select placeholder="Selecione o sexo" v-model="model.sexo">
                                                <option value="F">Feminino</option>
                                                <option value="M">Masculino</option>
                                                <option v-show="config.laboratorioVeterinario" value="I">Indeterminado</option>
                                            </b-select>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-half-mobile">
                                    <ValidationProvider rules="required" name="data de nascimento" v-slot="{ errors, valid }">
                                        <b-field label="Nascimento"
                                                 :message="errors"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }">
                                            <b-datepicker v-model="model.dataDeNascimento" trap-focus editable :max-date="new Date()" 
                                                :min-date="new Date(new Date().getFullYear() - 200, new Date().getMonth(), new Date().getDate())"></b-datepicker>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-half-mobile">
                                    <div class="field">
                                        <label class="label">Idade</label>
                                        <div class="control">
                                            <input class="input" type="text" @change="alterouIdade" :value="idade">
                                        </div>
                                    </div>
                                </div>
                                <div v-show="config.laboratorioVeterinario" class="column is-half-mobile texto-labels">
                                    <label class="label">Calcular Idade em</label>
                                    <b-select v-model="model.unidadeIdade">
                                        <option value="A">Anos</option>
                                        <option value="M">Meses</option>
                                        <option value="D">Dias</option>
                                    </b-select>
                                </div>
                                <div class="column is-half-mobile texto-labels">
                                    <div class="field">
                                        <label class="label">Peso (kg)</label>
                                        <div class="control">
                                            <input class="input" type="number" v-model="model.peso">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-half-mobile texto-labels">
                                    <div class="field">
                                        <label class="label">Altura (cm)</label>
                                        <div class="control">
                                            <input class="input" type="number" v-model="model.altura">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="email" name="e-mail" v-slot="{ errors, valid }">
                                        <b-field label="Email"
                                                 ref="email"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="email" v-model="model.email" @blur="verificarEmail" :readonly="model.possuiUsuario"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field">
                                        <label class="label">RG</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.rg" v-mask="'XXXXXXXXXXXXXXX'">                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="field">
                                        <label class="label">CPF</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.cpf" v-mask="'###.###.###-##'">
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="field">
                                        <label class="label">Cartão Nacional de Saúde</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.cartaoNacionalDeSaude">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="columns is-multiline is-mobile">
                                <div class="column is-three-quarters-mobile">
                                    <div class="field">
                                        <label class="label">Inscrição</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.inscricao">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-2-desktop is-one-quarter-mobile">
                                    <div class="field">
                                        <label class="label">D.V.</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.inscricaoDV" v-mask="'#'">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-4-desktop is-half-mobile">
                                    <div class="field">
                                        <label class="label">Validade</label>
                                        <div class="control">
                                            <b-datepicker editable v-model="model.validade" trap-focus></b-datepicker>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="columns is-multiline is-mobile">
                                <div class="column is-half-mobile">
                                    <div class="field">
                                        <label class="label">Plano</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.plano">
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-half-mobile">
                                    <div class="field">
                                        <label class="label">Titular</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.nomeDoTitular">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <searchIdName :id.sync="model.convenioPadraoId" label="Convênio Padrão" table="Convenio"></searchIdName>
                            <div v-show="config.laboratorioVeterinario && animal"><searchIdName :id.sync="model.racaId" label="Raça" table="Raca"></searchIdName></div>
                            <div v-show="config.laboratorioVeterinario && animal"><searchIdName :id.sync="model.especieId" label="Espécie" table="Especie"></searchIdName></div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field">
                                        <label class="label">Nome da Mãe</label>
                                        <div class="control">
                                            <input class="input" type="text" v-model="model.nomeDaMae">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <searchIdName :id.sync="model.responsavelId" label="Responsável" table="Paciente">
                                <slot>
                                    <b-button icon-left="plus-thick"
                                              tag="router-link"
                                              target="_blank"
                                              :to="{ name: 'paciente', query: { responsavel: true }}"
                                              title="Cadastrar Responsável"></b-button>
                                </slot>
                            </searchIdName>

                            <div class="columns">
                                <div class="column">
                                    <div class="field">
                                        <label class="label">Observações</label>
                                        <div class="control">
                                            <textarea class="textarea" v-model="model.observacoes"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </article>
                    </div>
                    <div class="tile is-parent is-3">
                        <article class="tile is-child is-12">
                            <article class="panel">
                                <div class="panel-heading has-text-centered">
                                    Usuário
                                </div>
                                <div v-if="!capturando">                                    
                                    <div class="panel-block">
                                        <figure class="image">
                                            <img :src="model.foto" ref="foto">
                                        </figure>
                                    </div>
                                </div>
                                <div v-else>                                    
                                    <div class="panel-block">
                                        <vue-web-cam ref="webcam"
                                                     :device-id="deviceId"
                                                     width="100%"
                                                     @cameras="onCameras" />
                                    </div>
                                    <div class="panel-block">
                                        <div class="field">
                                            <div class="select">
                                                <select v-model="camera">
                                                    <option>-- Select Device --</option>
                                                    <option v-for="device in devices"
                                                            :key="device.deviceId"
                                                            :value="device.deviceId">
                                                        {{ device.label }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-block tile is-12">                                    
                                        <b-button :class="capturando ? 'is-success  ' : 'is-link  '" 
                                                icon-left="camera"
                                                @click="onCapture" title="Clique para capturar pela webcam"
                                                expanded>
                                                Câmera
                                        </b-button>

                                        <div class="file has-name tile is-6">                                            
                                            <label class="file-label tile is-6" style="width: 100%;">
                                                <input class="file-input" type="file" name="foto" ref="fileSele" @change="imageFileSelected">
                                                <div class="file-cta tile is-12" style="">            
                                                    <span class="file-label" >
                                                        <i class="mdi mdi-file"></i> Arquivo
                                                    </span>
                                                </div>  
                                            </label>                                          
                                        </div>                                                                         
                                                                                                           
                                </div>
  
                                <div v-if="model.id" class="panel-block">
                                    <b-field>
                                        <b-switch v-model="model.desativado" type="is-danger">
                                            Desativado
                                        </b-switch>
                                    </b-field>
                                </div>
                                <div v-if="isInRole('usuarioweb-criar')" class="panel-block">
                                    <div class="field full-width">
                                        <b-switch v-model="model.criaUsuario" v-if="!model.possuiUsuario">
                                            Criar Usuário web
                                        </b-switch>
                                        <b-button v-if="model.possuiUsuario"
                                                  class="button is-danger "
                                                  @click="deletarUsuarioPaciente(model.id)"
                                                  expanded>
                                            Cancelar Usuário Web
                                        </b-button>

                                    </div>
                                </div>
                            </article>
                            <article v-if="model.id" class="panel">
                                <div class="panel-heading has-text-centered">
                                    Guias
                                </div>
                                <div class="panel-block is-justified-between tile is-12 btn-guias">
                                    
                                    <b-button class="tile is-4 " @click="criarGuia = true; onSubmit()">Criar</b-button>
                                    <router-link :to="{ name: 'guia-list', query: { pacienteId: model.id }}" class="button is-link tile is-4 ">
                                        Listar
                                    </router-link>
                                    <a :href="'/Rel/PlanilhaDeResultados?pacienteId=' + model.id" class="button is-info tile is-4 ">Resultados</a>
                                </div>
                            </article>

                            <historico-alteracoes :tabela="'Paciente'" :chave="model.id"></historico-alteracoes>

                            <article v-if="model.id" class="panel">
                                <div class="panel-heading has-text-centered">
                                    Documentos
                                </div>
                                <p v-if="carregando" class="panel-tabs">
                                    <b-loading :active.sync="carregando"></b-loading>
                                </p>
                                <div v-if="!arquivosCarregados" class="panel-block">
                                    <b-button expanded @click="buscarHistoricoArquivos">Listar...</b-button>
                                </div>
                                <a class="panel-block" v-for="(item, index) in historicoArquivos" v-bind:key="index" @click="buscarArquivo(index, item.extensao);">
                                    <span class="panel-icon">
                                        <i class="fas fa-book" aria-hidden="true"></i>
                                    </span>
                                    <pre :id="'arquivo_' + index" style="display:none;">{{item.arquivo64}}</pre>
                                    {{item.nome}}
                                </a>
                                <p v-if="arquivosCarregados && (historicoArquivos == null || historicoArquivos.length == 0) " class="panel-block">
                                    Nenhum documento
                                </p>
                            </article>
                            <article class="panel">
                                <div class="panel-heading has-text-centered">
                                    www.resultados.com.br
                                </div>
                                <div class="panel-block">
                                    <div class="field">
                                        <b-switch v-model="model.publicaResultadosNaInternet">
                                            Publicar resultados
                                        </b-switch>
                                    </div>
                                </div>
                                <p class="control has-icons-left">
                                    <input class="input" type="text" placeholder="Chave" v-model="model.senha">
                                    <span class="icon is-left">
                                        <i class="fas fa-key" aria-hidden="true"></i>
                                    </span>
                                </p>
                            </article>
                            <article class="panel">
                                <div class="panel-heading has-text-centered">
                                    Indicação
                                </div>
                                <div class="panel-block">
                                    <b-field>
                                        <b-select v-model="model.indicacao">
                                            <option v-for="opcaoIndicacao in opcoesIndicacao"
                                                    :value="opcaoIndicacao"
                                                    :key="opcaoIndicacao">
                                                {{ opcaoIndicacao }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </div>
                            </article>
                            <article class="panel">
                                <div class="panel-heading has-text-centered">
                                    Códigos integrações
                                </div>
                                <div class="panel-block">

                                    <div class="b-table tile is-12">                                    
                                        <div class="table-wrapper has-mobile-cards tile is-12">
                                            <table class="table is-striped is-hoverable">
                                                <thead>
                                                    <tr>                                                
                                                    <th class="">
                                                        <div class="th-wrap">
                                                            Tipo
                                                        </div>
                                                    </th>
                                                    <th class="">
                                                        <div class="th-wrap">
                                                            Código 
                                                        </div>
                                                    </th>                                                
                                                    </tr>                                   
                                                </thead>
                                                <tbody>

                                                <tr v-for="(item, index) in model.codigosIntegrador" v-bind:key="index">
                                                    <td>
                                                        <b-select placeholder="Integrador" v-model="item.integradorId" class="adicionar-codigo-integracao">
                                                            <option v-for="option in integradores"
                                                                    :value="option.id"
                                                                    :key="option.id">
                                                                {{ option.nome }}
                                                            </option>
                                                        </b-select>
                                                    </td>
                                                    <td>
                                                        <input class="input adicionar-codigo-integracao" type="text" v-model="item.codigo" >
                                                    </td>
                                                </tr>

                                                </tbody>
                                                <!---->
                                            </table>
                                        </div>

                                    </div>

                       
                                </div>
                                <div class="panel-block">
                                    <button type="button" class="button is-info is-fullwidth" @click="addCodigo">
                                        Adicionar código
                                    </button>
                                </div>
                            </article>
                            <article class="panel">
                                <div v-if="isInRole('guia-integradores-consultar')" class="panel-heading has-text-centered">
                                    <div v-if="integradores.some(x => x.versao == 12)">
                                        <div class="panel">
                                            <p class="panel-heading background-2">
                                                Buscar guia na operadora
                                            </p>
                                            <div class="panel-block is-justified-between">
                                                <b-input v-model="guiaOperadora"
                                                         name="guiaOperadora"
                                                         label="Guia na Operadora"
                                                         icon="magnify"></b-input>
                                            </div>
                                            <div class="panel-heading has-text-centered">
                                                <b-button type="is-primary"
                                                          @click="buscarGuiaOperadora()"
                                                          :loading="salvandoIntegrador">
                                                    Busca
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </article>
                    </div>
                </div>
                <nav class="level">
                    <div class="level-item">
                        <p class="buttons">
                            <b-button type="is-success"
                                      v-show="isInRole('paciente-alterar')"
                                      :loading="salvandoDados"
                                      native-type="submit"
                                      icon-left="check-circle">
                                Salvar
                            </b-button>
                            <b-button type="is-danger"
                                      native-type="button"
                                      icon-left="close-circle"
                                      @click="$router.back();">
                                Cancelar
                            </b-button>
                        </p>
                    </div>
                </nav>
            </form>
        </ValidationObserver>
    </section>
</template>

<style scoped >

    @import '../../assets/css/views/cadastro/paciente.css';

</style>

<script>
    import { mapGetters, mapState } from 'vuex'
    import buscaCepEndereco from '@/components/buscaCepEndereco.vue'
    import titlebar from '@/components/titlebar.vue'
    import searchIdName from '@/components/searchIdName.vue'
    import historicoAlteracoes from '@/components/historicoAlteracoes.vue'
    import modalEnviarSms from '@/components/modalEnviarSms.vue'

    export default {
        data() {
            return {
                model: {
                    id: null,
                    nome: this.$route.params.nome ?? null,
                    sexo: null,
                    dataDeNascimento: null,
                    cep: null,
                    endereco: null,
                    bairro: null,
                    cidadeId: null,
                    peso: null,
                    altura: null,

                    inscricao: null,
                    inscricaodv: null,
                    validade: null,
                    plano: null,
                    nomeDoTitular: null,
                    rg: null,
                    cpf: null,
                    cartaoNacionalDeSaude: null,
                    convenioPadraoId: null,
                    racaId: null,
                    especieId: null,
                    email: null,
                    nomedamae: null,
                    responsavelId: null,
                    observacoes: null,

                    codigosIntegrador: [],

                    criaUsuario: false,
                    indicacao: null,
                    publicaResultadosNaInternet: false,

                    foto: null,
                    unidadeDeCadastroId: this.unidadeId,
                    unidadeIdade: null,
                    guiaOperadora: null,
                    salvandoIntegrador: false
                },

                capturando: false,
                camera: null,
                deviceId: null,
                devices: [],
                carregando: true,
                historicoArquivos: [],
                salvandoDados: false,
                nomeSocial: false,
                animal: localStorage.animal == "true" ? true : false,
                fotoAlterada: false,
                criarGuia: Boolean(this.$route.params.criarGuia) ?? false,
                responsavel: Boolean(this.$route.query.responsavel) ?? false,

                arquivosCarregados: false,

                opcoesIndicacao: [
                    'Google',
                    'Facebook',
                    'Instagram',
                    'Panfleto',
                    'Revista',
                    'Médico',
                    'Amigo',
                    'Outros'
                ]
            };
        },
        components: {
            buscaCepEndereco,
            titlebar,
            searchIdName,
            historicoAlteracoes
        },
        created() {
            if (this.$route.params.id) {
                this.$http.get('/api/manutencao/paciente?id=' + this.$route.params.id)
                    .then(res => {
                        this.model = res.data;
                        if(this.model.dataDeNascimento){
                            this.model.dataDeNascimento = new Date(this.model.dataDeNascimento)
                        }
                        if (this.model.validade) {
                            this.model.validade = new Date(this.model.validade)
                        }
                        if (this.model?.foto){
                            if (this.model.foto.indexOf('data:image/') < 0){
                                this.model.foto = ` data:image/*;charset=utf-8;base64,${this.model.foto}`;
                            }
                        }
                        this.nomeSocial = this.model.nomeSocial != null
                        
                        this.model.criaUsuario = this.model.usuario != null

                        this.carregando = false
                    })
            }
            else {
                this.carregando = false;
            }
            this.model.publicaResultadosNaInternet = this.config.resultadoNaInternetAuto;
            this.model.criaUsuario = this.config.resultadoNaInternetAuto;
            
        },
        computed: {
            titleStack() {
                return [
                    'Manutenção',
                    'Paciente',
                    this.model.id ?? 'novo'
                ]
            },
            podeEnviarSms() {
                return this.model.celular && this.model.celular.length >= 14
            },
            iconeEnviarSms() {
                return this.podeEnviarSms
                    ? "cellphone-message"
                    : null
            },
            idade() {
                if(this.model.dataDeNascimento == null){
                    return "";
                }

                return this.calcularIdade();
            },
            device() {
                return this.devices.find(n => n.deviceId === this.deviceId);
            },
            ...mapState([
                'unidadeId',
                'config',
                'integradores'
            ]),
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {
            camera: function (id) {
                this.deviceId = id;
            },
            devices: function () {
                // Once we have a list select the first one
                const [first] = this.devices;
                if (first) {
                    this.camera = first.deviceId;
                    this.deviceId = first.deviceId;
                }
            }
        },
        methods: {
            buscarGuiaOperadora() {
                this.salvandoIntegrador = true;

                if(this.model.convenioPadraoId == 0 || this.model.convenioPadraoId == null || this.model.convenioPadraoId == '' || this.model.convenioPadraoId == undefined){
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: 'Convênio padrão obrigatório.',
                        type: 'is-danger',
                        queue: false
                    });
                    this.salvandoIntegrador = false;
                    return;
                }

                if(this.guiaOperadora == 0 || this.guiaOperadora == null || this.guiaOperadora == '' || this.guiaOperadora == undefined){
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: 'Número da guia na operadora obrigatório.',
                        type: 'is-danger',
                        queue: false
                    });
                    this.salvandoIntegrador = false;
                    return;
                }

                this.model.guiaOperadora = this.guiaOperadora;

                this.onSubmit();
            }, 
            calcularIdade(){
                if(this.model.dataDeNascimento > new Date()){
                    this.model.dataDeNascimento = null;
                    this.idade = null;

                    this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Valor informado para a data de nascimento inválido!',
                            type: 'is-danger',
                            queue: false
                        })

                    return;
                }

                const today = new Date();
                let m = today.getMonth() - this.model.dataDeNascimento.getMonth();
                                
                const dateAge = new Date(Date.now() - this.model.dataDeNascimento.getTime()); 
                const age = Math.abs(dateAge.getUTCFullYear() - 1970);
                                
                if(age > 200){
                    this.model.dataDeNascimento = null;
                    this.idade = null;

                    this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Valor informado para a data de nascimento inválido!',
                            type: 'is-danger',
                            queue: false
                        })

                    return;
                }

                if (age >= 1) {
                    if (age == 1) {
                        return ~~(age) + " ano";
                    } else {
                        return ~~(age) + " anos";
                    }
                } else {
                    if ((age == 0) && (m < 0)) {
                        m += 12;
                    }

                    if (today.getDate() < this.model.dataDeNascimento.getDate()) {
                        m--;
                    }

                    if (m > 0) {
                        if (m == 1) {
                            return ~~(m) + " mês";
                        } else {
                            return ~~(m) + " meses";
                        }
                    } else {
                        const d = (new Date(today.getFullYear(), today.getMonth(), today.getDate()) - this.model.dataDeNascimento) / 86400000;

                        if (d > 0) {
                            if (d == 1) {
                                return ~~(d) + " dia";
                            } else {
                                return ~~(d) + " dias";
                            }
                        } else {
                            return "";
                        }
                    }
                }
            },
            pacienteMenor(){

                if(this.model.dataDeNascimento == null){
                    return false;
                }

                const idade = parseInt(this.calcularIdade().replace(/\D/g,''));                    
                
                const possuiResponsavel = (this.model.responsavelId != 0 && 
                this.model.responsavelId != null && this.model.responsavelId != '' && this.model.responsavelId != undefined);
                

                return (idade<18 && possuiResponsavel);

            },
            alterouIdade(event) {
                const id = event.target.value.replace(",", ".");

                if (id < 1) {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: 'Valor informado para a idade inválido!',
                        type: 'is-danger',
                        queue: false
                    })

                    return;
                }

                if (this.model.unidadeIdade == "D") {
                    const dataNascimento = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                    const quantidade = (id * 24 * 60 * 60 * 1000);
                    this.model.dataDeNascimento = new Date(dataNascimento.valueOf() - quantidade);
                }
                else if (this.model.unidadeIdade == "M") {
                    const dataNascimento = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                    const quantidade = (id * 31 * 24 * 60 * 60 * 1000);
                    this.model.dataDeNascimento = new Date(dataNascimento.valueOf() - quantidade);
                }
                else {
                    this.model.dataDeNascimento = new Date(new Date().getFullYear() - id, new Date().getMonth(), new Date().getDate());
                }
            },
            verificarEmail() {
                this.$http.get(`/api/manutencao/VerificarUsuarioEmail?email=${this.model.email}`)
                    .then(res => {
                        if (res.data?.existe && !(res.data.tipo == 'paciente' && res.data.id == this.model.id)) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'O e-mail ' + res.data.email + ' já está sendo usado pelo usuario do ' + res.data.tipo + ' código ' + res.data.id,
                                type: 'is-danger',
                                queue: false
                            })
                            this.model.email = null
                        }
                    });
            },
            imageFileSelected: function(e) {
                const { name, type, size } = e.target.files[0];
                let imageData = null;
                const ref = this.$refs.foto;
                if (FileReader && size) { 
                    const fr = new FileReader();
                    fr.onload = () => {
                        imageData = fr.result;
                        this.model.foto = imageData;
                        this.fotoAlterada = true;
                        ref.src = imageData;
                    }
                    fr.readAsDataURL(e.target.files[0]);
                }
            },
            onSubmit() {
                localStorage.animal = this.animal

                if(this.animal){
                    //raça obrigatório e responsável obrigatório                    
                    if(this.model.racaId == 0 || this.model.racaId == null || this.model.racaId == '' || this.model.racaId == undefined){
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Raça obrigatória.',
                            type: 'is-danger',
                            queue: false
                        });
                        return;
                    }
               
                    if(this.model.especieId == 0 || this.model.especieId == null || this.model.especieId == '' || this.model.especieId == undefined){
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Espécie obrigatória.',
                            type: 'is-danger',
                            queue: false
                        });
                        return;
                    }

                    if(this.model.responsavelId == 0 || this.model.responsavelId == null || this.model.responsavelId == '' || this.model.responsavelId == undefined){
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Responsável obrigatório.',
                            type: 'is-danger',
                            queue: false
                        });
                        return;
                    }
                }
                else {
                    
                    if(this.config.cpfObrigatorio && !this.pacienteMenor()){
                                                
                        if(this.model.cpf == 0 || this.model.cpf == null || this.model.cpf == '' || this.model.cpf == undefined ){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'CPF obrigatório.',
                                type: 'is-danger',
                                queue: false
                            });
                            return;
                        }
                    }

                    if(this.config.enderecoObrigatorio){
                        if(this.model.endereco == 0 || this.model.endereco == null || this.model.endereco == '' || this.model.endereco == undefined){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'Endereço obrigatório.',
                                type: 'is-danger',
                                queue: false
                            });
                            return;
                        }
                    }

                    if(this.config.emailObrigatorio){
                        if(this.model.email == 0 || this.model.email == null || this.model.email == '' || this.model.email == undefined){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'Email obrigatório.',
                                type: 'is-danger',
                                queue: false
                            });
                            return;
                        }
                    }

                    if(this.config.celularObrigatorio){
                        if(this.model.celular == 0 || this.model.celular == null || this.model.celular == '' || this.model.celular == undefined){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'Celular obrigatório.',
                                type: 'is-danger',
                                queue: false
                            });
                            return;
                        }
                    }
                }

                if(this.config.convenioPadraoObrigatorioPaciente){
                    if(this.model.convenioPadraoId == 0 || this.model.convenioPadraoId == null || this.model.convenioPadraoId == '' || this.model.convenioPadraoId == undefined){
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Convênio padrão obrigatório.',
                            type: 'is-danger',
                            queue: false
                        });
                        return;
                    }
                }
                
                if (!this.nomeSocial && this.model.nomeSocial != null) {
                    this.model.nomeSocial = null
                }
                
                if(this.model.criaUsuario && this.model.email == null && !this.config.permiteCriarUsuarioParaPacienteSemEmail){
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: 'Não é possível criar usuário web sem email.',
                        type: 'is-danger',
                        queue: false
                    });
                    this.$refs.email.focus()
                    return;
                }
                
                if(this.config.cpfUnico && this.model.cpf != 0 && this.model.cpf != null && this.model.cpf != '' && this.model.cpf != undefined){
                    this.salvandoDados = true;

                    if(!this.model.id){
                        this.model.id = 0;
                    }

                    this.$http.get(`/api/manutencao/CheckCPF?cpf=${this.model.cpf}&id=${this.model.id}`)
                        .then(res => {
                            this.salvandoDados = false;
                            if(res.data > 0){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: 'Este CPF já está em uso.',
                                    type: 'is-danger',
                                    queue: false
                                })
                            }
                            else {
                                this.salvarPaciente();
                            }
                        })
                        .catch(err => {
                            this.salvandoDados = false;
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: 'Erro ao salvar paciente, verificando cpf: ' + err.body.title,
                                type: 'is-danger',
                                queue: false
                            })
                        })
                }
                else {
                    this.salvarPaciente();
                }

            },
            salvarPaciente(){
                this.salvandoDados = true;

                this.$http.post('/api/manutencao/paciente', this.model)
                    .then((res) => {
                        if(this.responsavel){
                            window.close();
                        }                 
                        else if (this.criarGuia) {
                            if(!this.model.desativado){
                                this.$router.push({
                                    name: 'novaguia', params: {
                                        pacienteId: res.data.id
                                    }
                                })
                            }else{
                                this.$router.back();
                            }
                        } else {
                            if(res.data.mensagem != null){
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: res.data.mensagem,
                                    type: 'is-info',
                                    queue: false
                                })
                            }
                            this.$router.back()
                        }
                        this.salvandoDados = false;
                    })
                    .catch(err => {
                        this.salvandoDados = false;
                        console.error(err);
                        Object.keys(err.body.errors).forEach(x => {
                            this.$store.commit('ADD_ERRO', x + ": " + err.body.errors[x])
                        })
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Erro ao salvar paciente: ' + err.body.title,
                            type: 'is-danger',
                            queue: false
                        })
                    })
            },
            addCodigo() {
                this.model.codigosIntegrador.push({
                    integradorId: null,
                    codigo: null
                });
            },

            onCapture() {
                if (this.capturando) {
                    this.model.foto = this.$refs.webcam.capture();
                    setTimeout(() => {
                        this.$refs.webcam.stop();
                        this.capturando = false;
                    }, 500);
                } else {
                    this.capturando = true;
                    setTimeout(() => { this.$refs.webcam.start() }, 500);
                }
            },
            onCameras(cameras) {
                this.devices = cameras;
                // console.log("On Cameras Event", cameras);
            },
            onCameraChange(deviceId) {
                this.deviceId = deviceId;
                this.camera = deviceId;
                // console.log("On Camera Change Event", deviceId);
            },
            buscarArquivo(index, extensao) {
                const base64Data = document.getElementById("arquivo_" + index).innerText;

                const sliceSize = 512;
                const byteCharacters = window.atob(base64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                console.log(extensao);
                console.log(base64Data);
                const blob = new Blob(byteArrays, {
                    type: 'application/' + extensao
                });

                const blobURL = URL.createObjectURL(blob);
                //window.open(blobURL);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = blobURL;
                link.download = "Documento." + extensao;
                link.click();
                window.URL.revokeObjectURL(blobURL);
                link.remove();
            },

            abrirModalSms() {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalEnviarSms,
                    props: {
                        numero: this.model.celular
                    },
                    hasModalCard: true,
                    trapFocus: true
                })
            },
            deletarUsuarioPaciente(id) {
                this.$http.get(`/api/manutencao/deletarUsuarioPaciente?pacienteId=${id}`).then(res => {
                      if(res.data.ok){
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: res.data.messagem,
                                type: 'is-success',
                                queue: false
                            })                           
                            this.$router.back();
                       }else{
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: res.data.messagem,
                                type: 'is-danger',
                                queue: false
                            })
                       }
                })
                    .catch(err => {
                        console.error(err)
                        Object.keys(err.body.errors).forEach(x => {
                            this.$store.commit('ADD_ERRO', x + ": " + err.body.errors[x])
                        })
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Erro ao salvar paciente: ' + err.body.title,
                            type: 'is-danger',
                            queue: false
                        })
                    })

            },
            buscarHistoricoArquivos() {
                this.carregando = true
                this.$http.get('/api/atendimento/historicoArquivosPaciente?pacienteId=' + this.$route.params.id)
                    .then(res => {
                        this.carregando = false
                        this.historicoArquivos = res.data
                        this.arquivosCarregados = true
                    })
                    .catch(err => {
                        this.carregando = false;
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Erro ao carregar histórico: ' + err.body.title,
                            type: 'is-danger',
                            queue: false
                        })
                    })
            }
        }
    }
</script>